import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import moment from "moment";
import { LanguageActions } from "redux/actions";
import i18n, { ELanguage } from "utils/i18n";
interface ILanguageState extends IBaseReducerState {
  language: ELanguage;
}

const initialState: ILanguageState = {
  action: LanguageActions.prefix,
  prefix: LanguageActions.prefix,
  language: ELanguage.VI,
};

const changeLanguage = (
  state: ILanguageState,
  action: PayloadAction<ELanguage>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.language = action.payload;
    moment.locale(action.payload);
    i18n.changeLanguage(action.payload);
  });

const LanguageReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder.addCase(LanguageActions.changeLanguage.request, changeLanguage);
  }
);

export default LanguageReducer;
